import server from "@/api/server";

export async function getGoods() {
  return server.get('agent/agent/bonuses/goods');
}

export async function orderGood(id) {
  return server.post('agent/agent/bonuses/order', { id });
}
